import type { GetRemainSeconds } from './types';

export const getRemainSeconds: GetRemainSeconds = (targetTimestamp) => {
  const currentTimestamp = Math.floor(Date.now() / 1000);

  return currentTimestamp <= targetTimestamp
    ? targetTimestamp - currentTimestamp
    : 0;
};
